import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "../../v2/pages/LoginPage/LoginPagev2";

// import Login from "../../v2/pages/LoginPage.js/LoginPage";
import PasswordForgotPage from "~components/pages/PasswordForgotPage";
import PasswordResetPage from "~components/pages/PasswordResetPage";

const AuthRoutes = () => {
  return (
    <>
      <Routes>
        {/* <Route path="/*" element={<Login />} /> */}
        <Route path="/*" element={<Login />} />

        <Route path="forgot-password" element={<PasswordForgotPage />} />
        <Route path="reset-password" element={<PasswordResetPage />} />
      </Routes>
    </>
  );
};

export default AuthRoutes;
